import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {HttpClientModule} from '@angular/common/http';

import {AppRoutingModule} from '@/app-routing.module';
import {AppComponent} from './app.component';
import {MainComponent} from '@modules/main/main.component';
import {LoginComponent} from '@modules/login/login.component';
import {HeaderComponent} from '@modules/main/header/header.component';
import {FooterComponent} from '@modules/main/footer/footer.component';
import {MenuSidebarComponent} from '@modules/main/menu-sidebar/menu-sidebar.component';
import {BlankComponent} from '@pages/blank/blank.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ProfileComponent} from '@pages/profile/profile.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RegisterComponent} from '@modules/register/register.component';
import {DashboardComponent} from '@pages/dashboard/dashboard.component';
import {ToastrModule} from 'ngx-toastr';
import {MessagesComponent} from '@modules/main/header/messages/messages.component';
import {NotificationsComponent} from '@modules/main/header/notifications/notifications.component';
import {ButtonComponent} from './components/button/button.component';

import {registerLocaleData} from '@angular/common';
import localeEn from '@angular/common/locales/en';
import {UserComponent} from '@modules/main/header/user/user.component';
import {ForgotPasswordComponent} from '@modules/forgot-password/forgot-password.component';
import {RecoverPasswordComponent} from '@modules/recover-password/recover-password.component';
import {LanguageComponent} from '@modules/main/header/language/language.component';
import {PrivacyPolicyComponent} from './modules/privacy-policy/privacy-policy.component';
import {MainMenuComponent} from './pages/main-menu/main-menu.component';
import {SubMenuComponent} from './pages/main-menu/sub-menu/sub-menu.component';
import {MenuItemComponent} from './components/menu-item/menu-item.component';
import {DropdownComponent} from './components/dropdown/dropdown.component';
import {DropdownMenuComponent} from './components/dropdown/dropdown-menu/dropdown-menu.component';
import { EmpresasComponent } from './pages/empresas/empresas.component';
import { SolicitudesComponent } from './pages/solicitudes/solicitudes.component';
import { VisasComponent } from './pages/visas/visas.component';
import { UsuariosComponent } from './pages/usuarios/usuarios.component';
import { FiltroClientePipe } from './pipes/filtro-cliente.pipe';
import { FormSolicitudComponent } from './modules/form-solicitud/form-solicitud.component';
import { ClientesComponent } from './pages/clientes/clientes.component';
import { ReservasComponent } from './pages/reservas/reservas.component';
import { ProveedoresComponent } from './pages/proveedores/proveedores.component';
import { CodigoIataComponent } from './pages/codigo-iata/codigo-iata.component';
import { FiltroIataPipe } from './pipes/filtro-iata.pipe';
import { FiltroProveedorActividadPipe } from './pipes/filtro-proveedor-actividad.pipe';
import { CandidatosComponent } from './pages/candidatos/candidatos.component';
import { PuestoVotacionComponent } from './pages/puesto-votacion/puesto-votacion.component';
import { VotacionComponent } from './pages/votacion/votacion.component';
import { FiltroUsuarioPipe } from './pipes/filtro-usuario.pipe';
import { MapaVotacionComponent } from './pages/votacion/mapa-votacion/mapa-votacion.component';
import { SectoresComponent } from './pages/sectores/sectores.component';
import { InscripcionComponent } from './pages/inscripcion/inscripcion.component';
import { EscrutinioComponent } from './pages/escrutinio/escrutinio.component';
import { MapaEscrutinioComponent } from './pages/escrutinio/mapa-escrutinio/mapa-escrutinio.component';

// registerLocaleData(localeEn, 'en-EN');
registerLocaleData(localeEn, 'es-ES');

@NgModule({
    declarations: [
        AppComponent,
        MainComponent,
        LoginComponent,
        HeaderComponent,
        FooterComponent,
        MenuSidebarComponent,
        BlankComponent,
        ProfileComponent,
        RegisterComponent,
        DashboardComponent,
        MessagesComponent,
        NotificationsComponent,
        ButtonComponent,
        UserComponent,
        ForgotPasswordComponent,
        RecoverPasswordComponent,
        LanguageComponent,
        PrivacyPolicyComponent,
        MainMenuComponent,
        SubMenuComponent,
        MenuItemComponent,
        DropdownComponent,
        DropdownMenuComponent,
        EmpresasComponent,
        SolicitudesComponent,
        VisasComponent,
        UsuariosComponent,
        FiltroClientePipe,
        FormSolicitudComponent,
        ClientesComponent,
        ReservasComponent,
        ProveedoresComponent,
        CodigoIataComponent,
        FiltroIataPipe,
        FiltroProveedorActividadPipe,
        CandidatosComponent,
        PuestoVotacionComponent,
        VotacionComponent,
        FiltroUsuarioPipe,
        MapaVotacionComponent,
        SectoresComponent,
        InscripcionComponent,
        EscrutinioComponent,
        MapaEscrutinioComponent,
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot({
            timeOut: 3000,
            positionClass: 'toast-top-right',
            preventDuplicates: true
        })
    ],
    providers: [],
    bootstrap: [AppComponent]
})
export class AppModule {}
